var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { publishMedicationList, unpublishMedicationList } from '../../Async/MedicationListsAsync';
import { Button, ButtonSize } from '../../Components/Button';
import { LockedPadlockIcon, UnlockedPadlockIcon } from '../../Components/Icons';
import { displayError } from '../../Config/ApplicationConfig';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';
import { getFirstErrorMessageFromApiError } from '../../Shared/DomainValidationFunctions';
import { white } from '../../Styles/Colours';
import styles from './PublishButton.module.css';
export function PublishButton(props) {
    var _this = this;
    var _a = __read(useState(false), 2), togglingState = _a[0], setTogglingState = _a[1];
    var draft = props.currentMedicationList.status === MedicationListStatus.Draft;
    var handlePublishClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var e_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setTogglingState(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!draft) return [3 /*break*/, 3];
                    return [4 /*yield*/, publishMedicationList(props.currentMedicationList.id)];
                case 2:
                    _a.sent();
                    props.onToggled(true);
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, unpublishMedicationList(props.currentMedicationList.id)];
                case 4:
                    _a.sent();
                    props.onToggled(false);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    error = getFirstErrorMessageFromApiError(e_1);
                    displayError(error);
                    return [3 /*break*/, 7];
                case 7:
                    setTogglingState(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: styles.publishContainer },
        React.createElement(Button, { testId: 'publish', size: ButtonSize.small, onClick: handlePublishClick, disabled: togglingState || props.disabled, startIcon: draft ? (React.createElement(LockedPadlockIcon, { noPadding: true, size: '20', color: white })) : (React.createElement(UnlockedPadlockIcon, { noPadding: true, size: '20', color: white })) }, draft ? 'Publish' : 'Unpublish')));
}
